'use client';

import useEmblaCarousel from 'embla-carousel-react';
import { useCallback } from 'react';
import { ReviewsProps } from '@/src/components/sections/Reviews';
import s from './styles.module.scss';
import { whereAreYou } from '@/src/mocks/where-are-you';
import Image from 'next/image';

export const WhereAreYou = ({ controls, options }: ReviewsProps) => {
    const [emblaRef, emblaApi] = useEmblaCarousel({
        align: 'start',
        dragFree: false,
        containScroll: 'trimSnaps',
        skipSnaps: false,
        slidesToScroll: 1,
        ...options,
    });

    const onPrev = useCallback(() => emblaApi?.scrollPrev(), [emblaApi]);
    const onNext = useCallback(() => emblaApi?.scrollNext(), [emblaApi]);

    return (
        <div className={s.root}>
            <div className={s.title_block}>
                <h2 className={s.title}>
                    Де ти проживеш
                    <br />
                    цих 7 днів?
                </h2>
                <Image src="/images/yan.png" alt="yan" width={121} height={127.54669952392578} />
            </div>

            <div className={s.viewport} ref={emblaRef}>
                <div className={s.container}>
                    {whereAreYou.map((r) => (
                        <article key={r.id} className={s.slide}>
                            <div className={s.card}>
                                <Image
                                    src={r.card}
                                    alt=""
                                    width={372.6737060546875}
                                    height={248.14614868164062}
                                />
                            </div>
                        </article>
                    ))}
                </div>

                <div className={`${s.controls} ${controls?.className ?? ''}`.trim()}>
                    <button
                        type="button"
                        className={`${s.navBtn} ${s.prev}`}
                        onClick={onPrev}
                        aria-label="Попередній відгук"
                    >
                        {controls?.prevContent ?? (
                            <Image
                                className={s.icon}
                                src="/icons/arrow_slider.svg"
                                alt=""
                                aria-hidden
                                width={20}
                                height={20}
                            />
                        )}
                    </button>
                    <button
                        type="button"
                        className={`${s.navBtn} ${s.next}`}
                        onClick={onNext}
                        aria-label="Наступний відгук"
                    >
                        {controls?.nextContent ?? (
                            <Image
                                className={s.icon}
                                src="/icons/arrow_slider.svg"
                                alt=""
                                aria-hidden
                                width={20}
                                height={20}
                            />
                        )}
                    </button>
                </div>
            </div>
        </div>
    );
};
